// extracted by mini-css-extract-plugin
module.exports = {"testimonials_container":"testimonials_testimonials_container__gV_jr","image_container":"testimonials_image_container__1ebz0","testimonial_li":"testimonials_testimonial_li__xm_vF"};